import { establishmentApi } from '@/core/api/establishment'

export const { useGetEstablishmentQuery, useGetEstablishmentBackgroundsQuery, useUpdateEstablishmentMutation } = establishmentApi
